import { render, staticRenderFns } from "./fansTag.vue?vue&type=template&id=b8b7f2e4&scoped=true"
import script from "./fansTag.vue?vue&type=script&lang=js"
export * from "./fansTag.vue?vue&type=script&lang=js"
import style0 from "./fansTag.vue?vue&type=style&index=0&id=b8b7f2e4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b7f2e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b7f2e4')) {
      api.createRecord('b8b7f2e4', component.options)
    } else {
      api.reload('b8b7f2e4', component.options)
    }
    module.hot.accept("./fansTag.vue?vue&type=template&id=b8b7f2e4&scoped=true", function () {
      api.rerender('b8b7f2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechats/fansTag.vue"
export default component.exports